// Dynamically import settings based on Vite mode
const isDev = import.meta.env.DEV;

let settings;
if (isDev) {
    settings = await import('./development.js');
} else {
    settings = await import('./production.js');
}

export default settings.default;
